import { createContext, useContext } from 'react';
import type { User } from '@/types';

export interface AuthContextType {
  user: User | null;
  setUser: (user: User | null) => void;
  isAuthenticated: boolean;
  isLoading: boolean;
  telegramUserData: any;
  pendingTelegramWelcome: boolean;
  login: (initData: string) => Promise<void>;
  loginWithEmail: (email: string, password: string) => Promise<void>;
  loginWithTelegram: () => Promise<void>;
  loginWithGoogle: () => Promise<void>;
  loginWithApple: () => Promise<void>;
  linkTelegramAccount: (email: string, password: string) => Promise<void>;
  handleTelegramEmailSubmit: (email: string, password: string, telegramData: any, mode: 'register' | 'link') => Promise<void>;
  registerTelegramOnly: (telegramData: any) => Promise<void>;
  bindEmail: (email: string, password: string) => Promise<void>;
  register: (data: RegisterData) => Promise<void>;
  registerWithTelegram: () => Promise<void>;
  registerWithGoogle: () => Promise<void>;
  registerWithApple: () => Promise<void>;
  deleteAccount: (password: string) => Promise<void>;
  clearPendingTelegramWelcome: () => void;
  logout: () => void;
  isGuest: boolean;
  isTelegramAvailable: boolean;
}

export interface RegisterData {
  first_name: string;
  last_name?: string;
  email: string;
  password: string;
  phone?: string;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export default useAuth;